/*
 * File: toaster.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:43 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 14, 2025 at 9:28 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import toast from 'react-hot-toast';

// Styles
import { DarkTheme, LightTheme } from '../styles/colors';

// Constants
import { UI_MODE_OPTIONS } from '../../constants/base.constants';


/**
 * Utilities
 */

const toastMessage = (uiMode, partner, message, options) => {

	// Define current theme
	const currentTheme = uiMode.mode === UI_MODE_OPTIONS.DARK ? DarkTheme(partner) : LightTheme(partner);

	// Make toast
	toast(message, {
		icon: '👋',
		style: {
			background: currentTheme.surfaceBackground,
			color: currentTheme.primaryText,
		},
		...options || { duration: 4000 }
	});
};

const toastSuccess = (uiMode, partner, message, options) => {

	// Define current theme
	const currentTheme = uiMode.mode === UI_MODE_OPTIONS.DARK ? DarkTheme(partner) : LightTheme(partner);

	// Make toast
	toast.success(message, {
		style: {
			background: currentTheme.surfaceBackground,
			color: currentTheme.primaryText,
		},
		...options || { duration: 6000 }
	});
};

const toastError = (uiMode, partner, message, options) => {

	// Define current theme
	const currentTheme = uiMode.mode === UI_MODE_OPTIONS.DARK ? DarkTheme(partner) : LightTheme(partner);

	// Make toast
	toast.error(message, {
		style: {
			background: currentTheme.surfaceBackground,
			color: currentTheme.primaryText,
		},
		...options
	});
};


/**
 * Exports
 */

export {
	toastMessage,
	toastSuccess,
	toastError
};
